/**
 * Monthly Target Model - Processes API responses for monthly target data
 */


/**
 * Monthly target list response data
 * @param {Object} response - API response from monthly target list endpoint
 * @returns {Object} Monthly target list data
 */
export const monthlyTargetListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch monthly target list',
        data: []
    };
};

/**
 * Process single monthly target details response
 * @param {Object} response - API response from monthly target details endpoint
 * @returns {Object} Formatted monthly target details
 */
export const monthlyTargetDetailsGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        const item = response.data.data || {};
        return {
            success: true,
            data: item
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch monthly target details',
        data: {}
    };
};

/**
 * Process monthly target creation response
 * @param {Object} response - API response from monthly target create endpoint
 * @returns {Object} Formatted creation response
 */
export const monthlyTargetCreatePost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Monthly target created successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to create monthly target',
        data: null
    };
};

/**
 * Process monthly target delete response
 * @param {Object} response - API response from monthly target delete endpoint
 * @returns {Object} Formatted delete response
 */
export const monthlyTargetDeleteDel = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Monthly target deleted successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to delete monthly target'
    };
};

/**
 * Process monthly target update response
 * @param {Object} response - API response from monthly target update endpoint
 * @returns {Object} Formatted update response
 */
export const monthlyTargetUpdatePut = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Monthly target updated successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to update monthly target',
        data: null
    };
};
